import { MutationFn } from '@percent/education-hosted-form/hooks/useMutation/useMutation.types'
import { HostedFormPrecheckResponse, RunHostedFormPrechecksProps } from './hostedFormPrecheck.types'

// Without a timeout a hung request would leave the user stuck on the spinner forever
// (the shared axios client sets none); on timeout they're sent to document upload instead.
const PRECHECK_TIMEOUT_MS = 10_000

export const runHostedFormPrechecks: MutationFn<RunHostedFormPrechecksProps, HostedFormPrecheckResponse> = async (
  client,
  { validationInviteId, ...body }
) => {
  const response = await client.post(`v1/validation-invites/${validationInviteId}/hosted-form-precheck`, body, {
    timeout: PRECHECK_TIMEOUT_MS
  })

  return response.data
}
